import * as _ from 'lodash';

import { PaymentGroupModel, paymentGroupInstanceTypes, remunerationTypeOrder } from '../PaymentGroupModel';
import { PaymentModel } from '../PaymentModel';
import { remunerationTypes } from '../../objects/Payslip';

/**
 * @typedef { import('../../objects/Claim').Claim } Claim
 * @typedef { import('../PayslipModel').PayslipModel } PayslipModel
 * @typedef { import('../objects/WageCalculation').WageCalculation } WageCalculation
 * @typedef { import('../calculation/PolitikerCalculator').PolitikerCalculator } PolitikerCalculator
 */

export class SimpleGroupModel extends PaymentGroupModel {

    /**
     * @param {PayslipModel} payslipModel
     * @param {number} remunerationType
     */
    constructor(payslipModel, remunerationType) {
        super(payslipModel);

        this.remunerationType = remunerationType;

        /** @type {WageCalculation|null} */
        this.wageCalculation = null;
    }

    get paymentGroupInstanceType() {
        return paymentGroupInstanceTypes.simple;
    }

    get isCollapsable() {
        return this.remunerationType === remunerationTypes.payment && !this.hasDetail;
    }

    get isManuallyCalculated() {
        return this.isAdded && (this.remunerationType === remunerationTypes.calculatedMeeting || this.remunerationType == remunerationTypes.calculatedTravel);
    }

    /**
     * 
     * @param {PaymentGroupModel} other 
     */
    compareTo(other) {
        if (!(other instanceof SimpleGroupModel)) return 0;
        return remunerationTypeOrder(this.remunerationType) - remunerationTypeOrder(other.remunerationType);
    }

    createAdd() {
        if (!this.isAdded) return null;

        let result = {
            RemunerationType: this.remunerationType,
            WageCalculationId: this.wageCalculation?.Id || null,
            Payments: this.payments.map(x => x.payment),
        };

        return result;
    }

    /**
     * @param {PayslipModel} payslipModel
     * @param {Remuneration} remuneration
     */
    static createExisting(payslipModel, remuneration) {
        let result = new SimpleGroupModel(payslipModel, remuneration.RemunerationType);
        result.remuneration = remuneration;
        result.claim = remuneration.Claim || null;
        result.payments = _.map(remuneration.Payments, x => PaymentModel.fromOriginal(result, x));
        result.sortPayments();
        return result;
    }

    /**
     * @param {PayslipModel} payslipModel
     * @param {number} remunerationType
     * @param {WageCalculation} wageCalculation
     * @param {CalculatedPayment[]} calculatedPayments
     */
    static createCalculated(payslipModel, remunerationType, wageCalculation, calculatedPayments) {
        let result = new SimpleGroupModel(payslipModel, remunerationType);
        result.wageCalculation = wageCalculation;
        result.payments = _.map(calculatedPayments, x => PaymentModel.fromCalculated(result, x));
        result.sortPayments();
        return result;
    }

    /**
     * @param {PayslipModel} payslipModel
     * @param {number}  remunerationType
     * @param {Payment[]} payments
     */
    static createManual(payslipModel, remunerationType, payments) {
        let result = new SimpleGroupModel(payslipModel, remunerationType);
        result.payments = _.map(payments, x => PaymentModel.fromCreated(result, x));
        result.sortPayments();
        return result;
    }
}
